<template>
    <content-layout>
        <template #header>Ask an Expert</template>
        <template #description>The team cards on the website's Ask an Expert page (lavishlocations.com/askanexpert).
            Only team members with a photo are shown there.</template>
        <template #header-right>
            <el-button type="primary" icon="el-icon-plus" @click="promptNewTeamMember">Add team member</el-button>
        </template>

        <h2 class="section-title">Team members</h2>
        <p class="help-text">Click a team member to edit their details.</p>

        <el-collapse>
            <el-collapse-item v-for="(teamMember, i) in teamMembers" :key="teamMember._id" :name="i">
                <template slot="title">
                    <img v-if="teamMember.image" :src="$imgix(teamMember.image, 80)" class="item-list__thumb team-thumb" alt="">
                    <span v-if="teamMember.name">{{ teamMember.name }}</span>
                    <span v-else class="item-list__empty-title">No name</span>
                    <span v-if="teamMember.role" class="item-list__meta team-role">{{ teamMember.role }}</span>
                </template>

                <el-form :model="teamMember" label-position="top">
                    <div class="form-grid">
                        <el-form-item label="Name">
                            <el-input v-model="teamMember.name"></el-input>
                        </el-form-item>
                        <el-form-item label="Role">
                            <el-input v-model="teamMember.role"></el-input>
                        </el-form-item>
                        <el-form-item label="Email">
                            <el-input v-model="teamMember.email"></el-input>
                        </el-form-item>
                        <el-form-item label="Phone Number">
                            <el-input v-model="teamMember.phone"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item label="Description">
                        <el-input type="textarea" :autosize="{minRows: 3, maxRows: 10}" v-model="teamMember.description"></el-input>
                    </el-form-item>
                    <el-form-item label="Image">
                        <el-upload
                                :action="rootpath +'/api/image'"
                                :headers="headers"
                                list-type="picture-card"
                                :before-remove="(file, fileList) => { removeImage(file, teamMember) }"
                                :multiple="false"
                                :limit="1"
                                name="image"
                                :file-list="teamMember.image ? [{name: teamMember.image, url: $imgix(teamMember.image, 200)}] : []"
                                :on-success="(response, file, fileList) => { teamMember.image = response.fileName , saveTeamMember(teamMember) }"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                    <div class="form-actions">
                        <el-button type="primary" @click="saveTeamMember(teamMember)">Save</el-button>
                        <el-button class="form-actions__right" type="danger" plain icon="el-icon-delete"
                                   @click="deleteTeamMember(teamMember)">Delete</el-button>
                    </div>
                </el-form>
            </el-collapse-item>
        </el-collapse>
    </content-layout>
</template>

<script>

    import teamMemberAPI from "../mixins/api/teamMemberAPI";
    import imageAPI from "../mixins/api/imageAPI";

    export default {
        name: "AskAnExpert",
        mixins: [teamMemberAPI, imageAPI],
        data() {
            return {

                newTeamMember: {
                    name: ''
                },

                teamMembers: [],

                rootpath: process.env.VUE_APP_ROOT_API,
                headers: {Authorization: localStorage.getItem('Authorization')},

            }
        },

        beforeMount: async function () {

            this.getTeamMembers();

        },

        methods: {

            async removeImage(file, teamMember) {
                try {
                    await this.imageAPI_delete(file.name);
                    teamMember.image = '';

                    await this.saveTeamMember(teamMember);

                    await this.getTeamMembers();
                    console.log('delete succesful');
                } catch (err) {
                    console.log('delete unsuccesful');
                    return false;
                }

            },

            async saveTeamMember(teamMember) {

                try {
                    await this.teamMemberAPI_patch(teamMember);
                    await this.getTeamMembers();

                    this.$notify({message: 'Details Updated', type: 'success'});
                } catch (err) {
                    this.$notify.error({message: err});
                }

            },

            promptNewTeamMember() {
                this.$prompt('Name', 'Add team member', {
                    confirmButtonText: 'Add',
                    cancelButtonText: 'Cancel',
                    inputValidator: value => !!(value && value.trim()) || 'Enter a name',
                }).then(({value}) => {
                    this.newTeamMember = {name: value.trim()};
                    return this.createTeamMember();
                }).catch(() => {
                });
            },

            async deleteTeamMember(teamMember) {
                try {
                    await this.$confirm(`Remove ${teamMember.name || 'this team member'} from the About page?`, 'Delete team member', {
                        confirmButtonText: 'Delete',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    });
                } catch (cancelled) {
                    return;
                }
                try {
                    await this.teamMemberAPI_delete(teamMember);
                    if (teamMember.image) {
                        // Best effort: the member is already gone if this fails.
                        this.imageAPI_delete(teamMember.image).catch(() => {});
                    }
                    await this.getTeamMembers();
                    this.$notify({message: 'Team member deleted', type: 'success'});
                } catch (err) {
                    this.$notify.error({message: err});
                }
            },

            async createTeamMember() {

                try {
                    await this.teamMemberAPI_create(this.newTeamMember);
                    this.newTeamMember = {};
                    await this.getTeamMembers();
                    this.$notify({message: 'Team Member Added', type: 'success'});
                } catch (err) {
                    this.$notify.error({message: err});
                }
            },

            async getTeamMembers() {
                this.teamMembers = await this.teamMemberAPI_get_all();
            }
        }
    }
</script>

<style scoped>
    .team-thumb {
        width: 32px;
        height: 32px;
        margin-right: 12px;
        border-radius: 50%;
    }

    .team-role {
        margin-left: 10px;
    }

    .form-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        column-gap: 24px;
    }
</style>



// WEBPACK FOOTER //
// src/site-content/AskAnExpert.vue